import classNames from 'classnames';

import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { HvButton, HvCopyInput, HvIconButton } from 'components';
import { images } from 'assets/images';
import { COLOR, ENG } from 'config/constants';

const useStyles = makeStyles({
  iconButton: {
    width: 'max-content',
    minWidth: 'auto',
    color: 'black',
    border: '2px solid #00bdf2',
  },
  title: {
    marginBottom: 10,
    marginRight: 30,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  detail: {
    position: 'relative',
    flexDirection: 'column',
  },
  copyButton: {
    marginTop: 20,
    width: 100,
    border: `1px ${COLOR.LIGHT_BLUE} solid`,
  },
  editButton: {
    marginTop: 20,
    marginLeft: 10,
    width: 100,
    border: `1px ${COLOR.LIGHT_BLUE} solid`,
  },
  languageTab: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
  langButton: {
    '&.MuiButton-root': {
      minWidth: 30,
    },
    '&:hover, &:focus': {
      backgroundColor: '#ebebeb',
    },
    backgroundColor: COLOR.LIGHT_GREY,
  },
  selectedLangButton: {
    backgroundColor: COLOR.LIGHT_BLUE,
    '&:hover, &:focus': {
      backgroundColor: COLOR.LIGHT_BLUE,
    },
    color: COLOR.WHITE,
    '&.MuiButton-root': {
      minWidth: 30,
    },
  },
  langText: {
    fontSize: 11,
  },
  generatedText: {
    marginTop: 35,
  },
  summary: {
    flexDirection: 'column',
  },
  descriptionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  time: {
    fontSize: 12,
  },
});
interface Props {
  previousDescriptions: [];
  setShowPreviousDescriptions: (showPreviousDescriptions: boolean) => void;
}
function Previous({ previousDescriptions, setShowPreviousDescriptions }: Props) {
  const intl = useIntl();
  const styles = useStyles();

  const [copied, setCopied] = useState<boolean>(false);

  const fmtCreateNewOne = intl.formatMessage({ id: 'deliver.descriptionGeneration.createNewOne' });
  const fmtPreviousDescriptions = intl.formatMessage({
    id: 'deliver.descriptionGeneration.previousDescriptions',
  });
  const fmtCopy = intl.formatMessage({ id: 'deliver.descriptionGeneration.copy' });
  const fmtCopied = intl.formatMessage({ id: 'deliver.descriptionGeneration.copied' });
  const fmtEdit = intl.formatMessage({ id: 'deliver.descriptionGeneration.edit' });

  const onCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.log('error copying to clipboard', err);
      });
  };

  const getText = (description) => {
    const text = description?.description?.data?.description;
    const edited_text = description?.description?.edited_text;
    return edited_text?.description || text;
  };
  return (
    <Box>
      <Box className={styles.row}>
        <Typography className={styles.title} variant='h4'>
          {fmtPreviousDescriptions}
        </Typography>
        <HvIconButton
          className={styles.iconButton}
          icon='add_new'
          text={fmtCreateNewOne}
          onClick={() => {
            return setShowPreviousDescriptions(false);
          }}
        />
      </Box>
      {previousDescriptions.map((description: any) => {
        const text = getText(description);
        if (!text) return null;
        return (
          <Accordion key={description.id}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box className={styles.summary}>
                <Typography className={styles.time}>
                  {moment
                    .utc(description.description.timestamp)
                    .local()
                    .format('h:mm A, dddd, MMM D, YYYY')}
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails className={styles.detail}>
              <Typography className={styles.generatedText}>{text}</Typography>
              <Box className={styles.row}>
                <HvIconButton
                  className={styles.copyButton}
                  icon='copy_blue'
                  text={copied ? fmtCopied : fmtCopy}
                  onClick={() => {
                    return onCopy(text);
                  }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}

export default Previous;
